const executedFunctionsUuid = new Set([])

// This is for the functions executed on the current device.
// This is used to prevent the same function from being executed multiple times.
export const addExecutedFunction = (uuid) => {
  executedFunctionsUuid.add(uuid)
}

export const hasExecutedFunction = (uuid) => {
  return executedFunctionsUuid.has(uuid)
}